export default __webpack_public_path__ + "static/media/Teams.b0e1b9ea.png";